export enum SortDropdownNameEnum {
  NAME_ASC = 'Text: A-Z',
  NAME_DESC = 'Text: Z-A',
  CREATED_NEWEST = 'Created: Newest First',
  CREATED_OLDEST = 'Created: Oldest First',
}
